export const tableColumn = [
	{
		label: '渠道名称',
		prop: 'name',

	},
	{
		label: '概率',
		prop: 'probability',
		width: '200px'
	},
	{
		label: '按规则分配',
		prop: 'channelRule',
		width: '200px'
	},
	{
		label: '描述',
		prop: 'description',
	},

	{
		label: '操作',
		prop: 'id',
		fixed: 'right',
		isCustomize: true,
		tableType: 'channelModify',
	},
]

export const forms = [
	[
		{
			label: '渠道名称',
			type: 'input',
			attr: 'name',
			placeholder: '请输入渠道名称',
			column: 24,
			labelWidth: '120px',
		},
	],
	[
		{
			label: '概率',
			type: 'inputNumber',
			attr: 'probability',
			placeholder: '请输入概率',
			column: 24,
			labelWidth: '120px'
		},
	],[
		{
			label: '按规则分配',
			type: 'inputNumber',
			attr: 'channelRule',
			placeholder: '开启请输入1',
			column: 24,
			labelWidth: '120px'
		},
	],

	[
		{
			label: '描述',
			type: 'input',
			attr: 'description',
			placeholder: '描述',
			column: 24,
			labelWidth: '120px',
		},
	],
]

export const dataSettingForms = [
	[
		{
			label: '数据权限类型',
			type: 'radio',
			attr: 'dataType',
			placeholder: '请选择权限类型',
			column: 24,
			labelWidth: '120px',
			option: [
				{ label: '个人', value: 0 },
				{ label: '部门', value: 1 },
			],
		},
	]
]
